import { Component, HostBinding } from '@angular/core';
import { RegexPatterns } from '../../constants/regex-patterns';
import { Masks } from '../../constants/masks';
import { EditSecretComponent } from '../edit-secret-component';

@Component({
  selector: 'lib-edit-ssn',
  templateUrl: './edit-ssn.component.html',
  styleUrls: ['./edit-ssn.component.scss'],
  inputs: EditSecretComponent.Inputs,
})
export class EditSsnComponent extends EditSecretComponent {
  constructor() {
    super({ pattern: RegexPatterns.ssn, mask: Masks.ssn });
  }

  @HostBinding('class') get getClass(): string {
    return super.getClass;
  }
}
